import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import pl from './i18n/pl.json';
import en from './i18n/en.json';

// Język z ?lang= (np. wejście z landingu EN/PL) ma priorytet i jest zapamiętywany.
const urlLang = (() => {
  try {
    const l = new URLSearchParams(window.location.search).get('lang');
    return l === 'en' || l === 'pl' ? l : null;
  } catch { return null; }
})();
if (urlLang) {
  try { localStorage.setItem('sp_lang', urlLang); } catch {}
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { pl: { translation: pl }, en: { translation: en } },
    fallbackLng: 'pl',
    lng: urlLang || localStorage.getItem('sp_lang') || 'pl',
    interpolation: { escapeValue: false },
  });

export default i18n;
